module.exports = __webpack_public_path__ + "img/beneflex.5810900e.svg";